import { ClusterDetailsResponse } from 'tabs/topQuestions/types/ApiResponses'

import {
  BeginClusteringResponse,
  START_CLUSTERING_REQ_PENDING,
  START_CLUSTERING_REQ__REJECTED,
  START_CLUSTERING_REQ_RESOLVED, StartClusteringReqRejected, StartClusteringReqResolved, StartClusteringReqPending,
} from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusTypes'
import { CLEAR_CLUSTER_QUESTION, ClearClusterQuestion, NEW_CLUSTER_QUESTIONS_RECEIVED, NewClusterQuestionsReceived } from 'tabs/topQuestions/lib/questions_content/questionsContentTypes'

export const newClusterQuestionsReceived = (payload: ClusterDetailsResponse): NewClusterQuestionsReceived => ({
  type: NEW_CLUSTER_QUESTIONS_RECEIVED,
  payload: payload,
})

export const clearClusterQuestion = (): ClearClusterQuestion => ({
  type: CLEAR_CLUSTER_QUESTION,
  payload: undefined,
})

export const startClusteringReqPending = (): StartClusteringReqPending => ({
  type: START_CLUSTERING_REQ_PENDING,
  payload: undefined,
})
export const startClusteringReqResolved = (payload: BeginClusteringResponse): StartClusteringReqResolved => ({
  type: START_CLUSTERING_REQ_RESOLVED,
  payload,
})

export const startClusteringReqRejected = (): StartClusteringReqRejected => ({
  type: START_CLUSTERING_REQ__REJECTED,
  payload: undefined,
})

